import { FC, ReactNode } from 'react';
import { useWbTabsContext } from './WbTabsContext';

interface TabPanelProps {
  children?: ReactNode;
  value: number;
  index: number;
  className?: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, className } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      className={className}
    >
      {value === index && children}
    </div>
  );
}

interface WbTabPanelProps {
  children?: ReactNode;
  index: number;
  className?: string;
}

export const WbTabPanel: FC<WbTabPanelProps> = ({
  children,
  index,
  className,
}) => {
  const { value } = useWbTabsContext();

  return (
    <TabPanel value={value} index={index} className={className}>
      {children}
    </TabPanel>
  );
};
